//translation
import { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next'
import { useLanguageContext } from "../../context/languageContext/LanguageContext";
import LanguageOptionBox from "./languageOptionBox/LanguageOptionBox";
//import icons and styles 
import {imgIcon, buttonStyle} from "./languageStyle"

export default function LanguageChanger() {
  const { t } = useTranslation()
  const { IsLanguageOptionActive, SetIsLanguageOptionActive} = useLanguageContext(); 
  const [label, SetLabel] = useState(<>{t('language')}</>);
  const [img, SetImg] = useState(imgIcon.languageIcon);
  const [ButtonStyle, SetButtonStyle] = useState(buttonStyle.hover);

  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef);

  useEffect(() => {
    if(IsLanguageOptionActive){
      SetLabel(<>{t('close')}</>)
      SetImg(imgIcon.closeIcon)
    }else{
      SetLabel(<>{t('language')}</>)
      SetImg(imgIcon.languageIcon)
    }
  },[IsLanguageOptionActive, t])
  
  function staticAnimation(){
    SetButtonStyle(buttonStyle.static)
  }

  function openLanguageOptionBox (){
    if(IsLanguageOptionActive){
      SetIsLanguageOptionActive(false)
    }else{
      SetIsLanguageOptionActive(true)
    }
  }
  return (
    <div ref={wrapperRef}>
      <button id="LanguageChanger" onClick={openLanguageOptionBox} style={ButtonStyle} onMouseOver={staticAnimation} onMouseOut={staticAnimation}>
        <div className="icon">
          <img className="img Static" src={img.static} alt={label} />
          <img className="img Hover" src={img.hover} alt={label} />
        </div>
        <span className="label">
          {label}
        </span>
      </button>
      <LanguageOptionBox />
    </div>
  );
}

function useOutsideClick(ref) {
  const { SetIsLanguageOptionActive} = useLanguageContext(); 

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        SetIsLanguageOptionActive(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}